module.exports = __webpack_public_path__ + "static/media/_bitcoin-btc.43aa81e3.svg";